<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('region')">
          <el-select v-model="queryForm.region" size="small">
            <el-option :label="$t('all')" value=""></el-option>
            <template v-for="(item, index) in countryList">
              <el-option-group
                v-if="item.parentId == 0"
                :key="index"
                :label="item.name"
              >
                <template v-for="(it, i) in countryList">
                  <el-option
                    v-if="it.parentId == item.id"
                    :key="i + index.toString()"
                    :label="it.name"
                    :value="it.id"
                  ></el-option>
                </template>
              </el-option-group>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-row class="table-btns">
        <a @click="downloadEXCEL()" type="text" size="mini"
          ><i class="el-icon-download"></i> {{ $t("downloadEXCEL") }}</a
        >
      </el-row>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="table.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          fixed="left"
          prop="orgName"
          :label="$t('orgName')"
          width="300"
        >
          <template slot-scope="scope">
            {{ scope.row.orgName }} ({{ scope.row.orgInfoCode }})
          </template>
        </el-table-column>

        <el-table-column
          prop="accountAmount"
          :label="$t('accountAmount')"
          width="250"
        >
          <template slot-scope="scope">
            <span class="franc">FCFA</span
            >{{ scope.row.accountAmount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cashAmount"
          :label="$t('cashAmount')"
          width="250"
        >
          <template slot-scope="scope">
            <span class="franc">FCFA</span
            >{{ scope.row.cashAmount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="country"
          :label="$t('nation') + ' / ' + $t('region')"
          width="220"
        >
          <template slot-scope="scope">
            {{ getNationProvinceUrban(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--End Data Table-->
    <div
      style="display: flex; align-items: center; justify-content: space-between;"
    >
      <el-pagination
        background
        layout="total,sizes,prev,pager,next,jumper"
        :total="table.total"
        :page-sizes="[20, 30, 50, 100, 200]"
        :page-size="pageSize"
        :current-page="currentPage"
        @size-change="setPageSzie"
        @current-change="setCurrentChange"
        @prev-click="setCurrentChange"
        @next-click="setCurrentChange"
      />
      <div style="padding: 0 10px; font-size: 13px; color: #606266;">
        <span>{{ $t("accountAmount") }}: </span>
        <span class="franc">FCFA</span>
        <strong>{{ totalAccountAmount.formatMoney(0) }}</strong>
        &nbsp;&nbsp; ||**||
        <span>{{ $t("cashAmount") }}: </span>
        <span class="franc">FCFA</span>
        <strong>{{ totalCashAmount.formatMoney(0) }}</strong>
      </div>
    </div>
  </el-card>
</template>

<script>
import org from "@/api/org";
import qs from "qs";
import card from "@/api/card";
export default {
  name: "regionalBalances",
  data() {
    return {
      queryForm: {},

      queryTableHeight: String,
      orgList: [],
      totalAccountAmount: 0,
      totalCashAmount: 0,
      table: {},
      pageSize: 20,
      currentPage: 1,
      isLoading: false, //
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    cascader() {
      return this.$store.state.format.cascader;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    rules() {
      return {};
    },
    downloadUrl() {
      let param = JSON.parse(JSON.stringify(this.queryForm));
      return card.regionalBalancesExport + "?" + qs.stringify(param);
    },
  },
  watch: {},

  methods: {
    getList() {
      let _this = this;
      _this.table.records = [];
      _this.isLoading = true;
      //let params = JSON.parse(JSON.stringify(_this.queryForm))
      //console.log("Hello", params.region)

      card.pageRegionalBalances({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm,
        },
        success: (res) => {
          _this.isLoading = false;
          _this.table = res.data.page || {};
          _this.totalAccountAmount = res.data.totalAccountAmount || 0;
          _this.totalCashAmount = res.data.totalCashAmount || 0;
        },
      });
    },
    getNationProvinceUrban(row) {
      let c = this.countryList.find(function(c) {
        return row.country == c.id;
      });
      let r = this.countryList.find(function(c) {
        return row.region == c.id;
      });
      let cr = (c ? c.name : "") + " / " + (r ? r.name : "");
      return cr;
    },
    downloadEXCEL() {
      let download = document.createElement("a");
      download.href = this.downloadUrl;
      download.download = "";
      download.click();
    },
    getOrgList() {
      let _this = this;
      org.getOrgInfoPage({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) _this.orgList = res.data.records;
        },
      });
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";

    this.getList();

    this.getOrgList();
  },
};
</script>
<style lang="less">
.table-btns a {
  cursor: pointer;
}
</style>
